import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormGroupDirective, FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

import { LoaderService } from '@teem/services/loader.service';
import { InputTaxForm } from '@teem/model-forms/input-tax-form';
import { messages as i18n } from '@teem/constants/messages';
import { TaxService } from '@teem/services/tax.service';
import { parseDate } from '@teem/helpers/functions';
import { Taxes } from '@teem/models/taxes';

@Component({
  selector: 'app-add-expense',
  templateUrl: './add-expense.component.html',
  styleUrls: []
})
export class AddExpenseComponent implements OnInit {

  @ViewChild('newInputTaxForm') newInputTaxForm: FormGroupDirective;
  @ViewChild('receiptInvoicePhoto') myPond: any;
  inputTaxForm: FormGroup;
  submitted: boolean = false;
  receiptFile: any;
  formData = new FormData();
  
  pondOptions = {
    multiple: false,
    allowReplace: false,
    allowRemove: true,
    allowImageResize: true,
    allowImagePreview: true,
    imageResizeMode: 'cover',
    acceptedFileTypes: 'image/png, image/jpeg, image/gif',
    labelIdle: `<span class="icon-upload"></span>`
  };

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private loaderService: LoaderService,
    private el: ElementRef,
    private taxService: TaxService,
  ) { }

  ngOnInit(): void {
    this.inputTaxForm = this.fb.group(new InputTaxForm(new Taxes()));
    this.inputTaxForm.controls['net_vat_amount_percent'].disable();
  }

  get f() {
    return this.inputTaxForm.controls;
  }

  updateCast(vat_percentage, taxable_amount) {
    this.inputTaxForm.controls.net_vat_amount_percent.setValue(((vat_percentage / 100) * taxable_amount).toFixed(2));
    this.inputTaxForm.controls.cost.setValue(taxable_amount);
  }

  onFileChange(event) {
    if (event.target.files.length > 0) {
      this.receiptFile = event.target.files[0];
    }
  }

  removeFile() {
    this.receiptFile = null;
  }

  pondHandleInit() {
    // console.log('FilePond has initialised', this.myPond);
  }

  pondHandleAddFile(event: any) {
    // console.log(this.myPond);
    if(this.formData.has('receipt_file')){
      this.formData.set('receipt_file', event.file.file);  
    }else{
      this.formData.append('receipt_file', event.file.file);
    }
  }

  onSubmit() {
    this.submitted = true;
    let fd: any = this.inputTaxForm.value;
    fd.expense_date = parseDate(fd.expense_date);
    fd.cost = fd.taxable_amount;

    if (this.inputTaxForm.valid) {
      this.loaderService.startLoading();

      let fd: any = this.inputTaxForm.value;
      fd.expense_date = parseDate(fd.expense_date);
      fd.cost = fd.taxable_amount;

      if(this.formData.has('receipt_file')){
        fd.receipt_file = this.formData.get('receipt_file');
      }

      // if (this.receiptFile) {
      //   fd.receipt_file = this.receiptFile;
      // }

      this.taxService.create(fd, { headers: { 'Content-Type': 'multipart/form-data' } }).subscribe(data => {
        this.loaderService.stopLoading();

        this.inputTaxForm.reset();
        this.activeModal.close(data);

        Swal.fire(i18n.done, i18n.taxes.tax_saved, 'success');
        this.submitted = false;

      }, err => {
        this.loaderService.stopLoading();

        // Set server side error
        if (err.status === 422) {
          if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
            let validationErrors = err.error.errors;
            Object.keys(validationErrors).forEach((prop) => {
              this.inputTaxForm.get(prop)?.setErrors({
                serverError: validationErrors[prop]
              })
            })
          }
        }

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

}
